import { Route } from "@angular/router";
import { TravelListComponent } from "./components/travel-list/travel-list.component";
import { TravelService } from "../api/services/travel.service";
import { UserService } from "../api/services/user.service";
import { TravelDetailsService } from "./services/travel-details.service";
import { VehicleTypesService } from "../api/services/vehicle-types.service";
import { UploadImageService } from "../api/services/upload-image.service";
import { LicenseCategoryService } from "../api/services/license-category.service";

export default [
    {
      path: '',
      component: TravelListComponent,
      providers: [
        TravelService,
        LicenseCategoryService,
        UserService,
        TravelDetailsService,
        VehicleTypesService,
        UploadImageService
      ]
    },
  ] as Route[];